import ProductPricingForm from '@app/components/apps/ProductPricing/ProductPricingForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Row, Col } from 'antd';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const EditProductPricingPage = () => {
  const location = useLocation();
  const { id, product_category_id, product_id, product_variety_id } = location.state || {};
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Loading...');

  const routes = [
    {
      path: '/product-pricings',
      breadcrumbName: 'Product Pricings',
    },
    {
      path: '/edit-product-pricing',
      breadcrumbName: currentBreadcrumName,
    },
  ];
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <BaseBreadcrumbWithRender routes={routes} />
        </Col>
        <Col span={24}>
          {' '}
          <ProductPricingForm
            mode="edit"
            product_category_id={product_category_id}
            product_id={product_id}
            product_variety_id={product_variety_id}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'Edit Product Pricing'}
            id={id}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditProductPricingPage;
